module.exports = __webpack_public_path__ + "img/设置.a315e0c6.png";